<template>
  <VModal @close="$emit('close')">
    <div
      class="mx-auto bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl lg:max-w-lg sm:w-full sm:p-6"
    >
      <LinkedAccountList
        :page="page"
        :linked-accounts="page.accounts"
        @changed="fetchFacebookPage"
      />
      <AccountOptionList
        ref="pageAccountLink"
        :page-id="pageId"
        :linked-accounts="page.accounts || []"
        @changed="fetchFacebookPage"
      />
    </div>
  </VModal>
</template>

<script>
import LinkedAccountList from './LinkedAccountList.vue';
import AccountOptionList from './AccountOptionList.vue';

export default {
  components: {
    LinkedAccountList,
    AccountOptionList,
  },
  props: {
    pageId: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    page() {
      return this.$store.state.entities.facebookPages.byId[this.pageId];
    },
  },
  created() {
    this.fetchFacebookPage();
  },
  methods: {
    disablePageAccountLink(disabled) {
      const pageAccountLinkRef = this.$refs.pageAccountLink;

      if (!pageAccountLinkRef) {
        return;
      }

      pageAccountLinkRef.disabled = disabled;
    },
    async fetchFacebookPage() {
      try {
        await this.$store.dispatch('admin/facebookPages/read', {
          id: this.pageId,
          query: {
            include: 'accounts',
          },
        });
      } catch (error) {
        // catch any errors
      }
    },
  },
};
</script>
